<!--
<template>
  <a-form :form="form" @submit.prevent="onSubmit">
    <a-form-item label="email" v-bind="errorsBind('email')">
      <a-input
        type="text"
        v-model="form.email"
        auto-complete="off"
        placeholder="adres email"
      >
      </a-input>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" html-type="submit">
        <span>Login</span>
      </a-button>
    </a-form-item>
  </a-form>
</template>
-->

<script>
import { get } from 'lodash'

export default {
  props: {
    value: { type: [Object, Array], required: false },
    errors: { type: [Object, Array], required: true },
    isDirty: { type: Boolean, default: true }
  },
  methods: {
    onSubmit() {
      this.$emit('submit')
    },
    removeFormsetItem(item) {
      const index = this.form.indexOf(item)
      if (index > -1) {
        this.form.splice(index, 1)
      }
    },
    addFormsetItem() {
      // use if you make formset
      const blankObject = this.getBlankObject()
      if (this.form === undefined) {
        this.form = [blankObject]
      } else {
        this.form = [...this.form, blankObject]
      }
    },
    getBlankObject() {
      return {}
    }
  },
  computed: {
    form: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value
      }
    },
    errorsBind() {
      return (...field) => {
        const errors = get(this.errors, field)
        const text = Array.isArray(errors) ? errors.join(',') : errors
        if (field[0] === 'non_field_errors' && !text) {
          return { style: 'display: none;' }
        }
        return {
          'validate-status': errors ? 'error' : '',
          help: text ? text : ''
        }
      }
    }
  }
}
</script>
